var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticClass: "form-table",
          attrs: {
            "row-key": function (record) {
              return record.key
            },
            data: _vm.model,
          },
        },
        [
          [
            _c("el-table-column", {
              attrs: {
                label: "序号",
                align: "center",
                type: "index",
                width: "50",
              },
            }),
            _vm._l(_vm.fields, function (option, index) {
              return [
                _c("el-table-column", {
                  key: index,
                  attrs: {
                    label: _vm.getTableColumnLabel(option),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.showText(scope.row, option.vModel)) +
                                " "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ]
            }),
            _c("el-table-column", {
              attrs: { label: "操作", align: "center", width: "300" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.handleViewData(scope.$index, scope.row)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-view" }),
                          _vm._v("查看 "),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "详情",
            visible: _vm.dialogVisible,
            width: "40%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("ViewData", {
            attrs: {
              fields: _vm.viewFields,
              "page-form-model": _vm.pageFormModel,
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }